// extracted by mini-css-extract-plugin
module.exports = {"left":"styles_left__BF8O1","right":"styles_right__1M9wb"};